import { risksAPI } from "services/swagger-api/riskApi"
import { SubscriptionProcessSyncActions } from ".."
import { borrowerContractualizationStore } from "features/subscription-process/contractualization-process/store/borrowerContractualizationStore"
import { BorrowerContractualizationResponse } from "api/quote"

export const fetchBorrowerProject = async (
  borrowerProjectId: string,
  actions: SubscriptionProcessSyncActions,
): Promise<void> => {
  try {
    actions.setLoading(true)
    actions.setError(null)

    const response = await risksAPI.getSubscriptionProcessBorrower({ projetEmpruntId: borrowerProjectId })

    if (response) {
      actions.initSubscriptionData({
        ...response,
      })

      if (response.contractualizationData) {
        borrowerContractualizationStore.actions.setGlobalInfos(
          response.contractualizationData as BorrowerContractualizationResponse
        )
      }
    }
  } catch (error) {
    actions.setError(error instanceof Error ? error.message : "Une erreur est survenue")
  } finally {
    actions.setLoading(false)
  }
}
